import { render, staticRenderFns } from "./OTPVerification.vue?vue&type=template&id=80e39348&scoped=true"
import script from "./OTPVerification.vue?vue&type=script&lang=js"
export * from "./OTPVerification.vue?vue&type=script&lang=js"
import style0 from "./OTPVerification.vue?vue&type=style&index=0&id=80e39348&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80e39348",
  null
  
)

export default component.exports